import React from 'react'
import { CoreContainer } from '@hub/core-container'
import { Feature } from '@scentregroup/shared/hub-components/feature'
import { SGPageTemplateContentCollection } from '../../../../../../src/types/page-templates'
import { ModuleProps } from '../../types'

export default function SGPageTemplateContentCollectionFeatureModule({
  module,
}: ModuleProps<SGPageTemplateContentCollection>): JSX.Element | null {
  if (module.items.length === 0) {
    return null
  }
  return (
    <CoreContainer>
      <Feature
        slides={module.items}
        analyticsSlot={module.analyticsMetadata?.displayId}
      />
    </CoreContainer>
  )
}
